const getTranslator = () => JSON.parse(sessionStorage.getItem('translator'))
const saveTranslator = (translator) => {
  sessionStorage.setItem('translator', JSON.stringify(translator))
}
const removeTranslator = () => {
  sessionStorage.removeItem('translator')
}

export default {
  getTranslator,
  saveTranslator,
  removeTranslator,
}
